import React, { useState, useEffect } from "react";
import axios from "axios";

import { Container, Card, Form, Row, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

import { toast } from "react-toastify";
import { STUDENT_ASSIGNMENT_API } from "../../../api/api";

import { handleApiError } from "../../../utils/apiErrorHandler";

import "./StudentAssignmentResult.css";

const StudentAssignmentResult = () => {
  const navigate = useNavigate();
  const { assignmentId } = useParams();

  const [assignmentTitle, setAssignmentTitle] = useState("");
  const [questions, setQuestions] = useState([]);

  //loading
  const [loadingAssignmentResult, setLoadingAssignmentResult] = useState(true);

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      setLoadingAssignmentResult(false);
      navigate("/signin");

      return;
    }

    const fetchAssignmentResult = async () => {
      try {
        const response = await axios.post(
          STUDENT_ASSIGNMENT_API.GET_STUDENT_ASSIGNMENT_RESULT,
          {
            student_id: userId,
            assignment_id: assignmentId,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          setAssignmentTitle(data.data.assignment_title);
          const formattedQuestions = (data.data.questions || []).map(
            (q, idx) => ({
              questionId: q.question_id,
              question: q.question,
              options: [
                { key: "a", value: q.a },
                { key: "b", value: q.b },
                { key: "c", value: q.c },
                { key: "d", value: q.d },
              ],
              index: idx + 1,
              correctAnswer: q.correct_answer,
              selectedAnswer: q.selected_answer || "",
              isCorrect: q.is_correct,
            }),
          );

          setQuestions(formattedQuestions);
        } else {
          // This will handle any 2xx response that is not 201
          showErrorToast(data.message);
        }
      } catch (error) {
        console.error(error);
        // Server responded with non-2xx status (like 400, 500)

        // CHECK (expiry / invalid token)
        if (error.response?.status === 404) {
          setTimeout(() => {
            navigate("/student/assignments");
          }, 1000);
          return; // ← handle 404 separately
        }
        handleApiError(error, navigate, showErrorToast, "/signin");
      } finally {
        setLoadingAssignmentResult(false);
      }
    };

    fetchAssignmentResult();
  }, [assignmentId, navigate]);

  // Score Calculation
  const score = questions.filter((q) => q.isCorrect).length;

  return (
    <Container fluid className="student-certificate-section-container">
      {loadingAssignmentResult ? (
        <div className="text-center mt-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div className="student-assignment-result-page">
          <div className="student-assignment-result-header">
            <div className="student-dashboard-backmoving-button-wrapper">
              <button
                className="student-dashboard-backmoving-button-main"
                onClick={() => navigate(-1)}
              >
                <IoArrowBack className="student-dashboard-backmoving-button-icon" />
                <span className="student-dashboard-backmoving-button-text">
                  Back
                </span>
              </button>
            </div>

            <Row className="align-items-center mb-2">
              <h2 className="student-certificate-section-title">
                Assignment Result
              </h2>
              {/* <p className="student-certificate-section-description mt-2">
                Total Score: {score} / {questions.length}
              </p> */}
            </Row>

            <div className="student-assignment-header mb-2">
              <h4 className="student-assignment-header-title">
                {assignmentTitle}
              </h4>

              <div className="student-assignment-header-meta">
                <span>Normal Assignment</span>
                <span className="dot">•</span>
                <span className="student-assignment-header-meta-spannn">
                  Total Score: {score} / {questions.length} Questions
                </span>
              </div>
            </div>
          </div>

          <div className="student-assignment-result-body">
            <Card className="student-assignmentcomplete-details-card">
              {questions.map((q) => (
                <div
                  key={q.questionId}
                  className={`student-assignmentcomplete-details-question-box
             ${q.isCorrect ? "student-assignmentcomplete-correct" : "student-assignmentcomplete-wrong"}`}
                >
                  <div className="student-assignmentcomplete-details-question-title">
                    {q.index}. {q.question}
                  </div>

                  <Form>
                    {q.options.map((opt) => (
                      <Form.Check
                        key={opt.key}
                        type="radio"
                        label={opt.value}
                        checked={q.selectedAnswer === opt.key}
                        disabled
                        className="student-assignmentcomplete-details-option"
                      />
                    ))}
                  </Form>

                  {!q.isCorrect && (
                    <div className="correct-assignmentcomplete-text">
                      Correct Answer: {q.correctAnswer}
                    </div>
                  )}
                </div>
              ))}
            </Card>
          </div>
        </div>
      )}
    </Container>
  );
};

export default StudentAssignmentResult;
